import * as urls from "../../api/aggregator";
import { getProperty } from "../../utility/getProperty";
import { getRequest } from "../RestServices";

export const getInstallerNameLookUp = async (workOrderNumber) => {
  const encodedWorkOrderNumber = encodeURIComponent(workOrderNumber);
  const response = await getRequest(`${urls.INSTALLER_NAME_LOOKUP}/${encodedWorkOrderNumber}`);
  const data = getProperty(response, "data.data", null) ?? getProperty(response, "data", []);
  return Array.isArray(data) ? data : [];
};
